module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_3009.1d4e8276.png";